import React from 'react';

import PropTypes from 'prop-types';
import getComponentWithTheme from '../../themeProvider';
import LoginPageContext from './LoginPageContext';

const LoginPage = (props) => {
	const {
		ssoConnection,
		isMarketplace,
		mfaRequired,
		csrfToken,
		googleUrl,
	} = props;

	return (
		getComponentWithTheme(
			<LoginPageContext
				ssoConnection={ssoConnection}
				isMarketplace={isMarketplace}
				mfaRequired={mfaRequired}
				csrfToken={csrfToken}
				googleUrl={googleUrl}
			/>,
			window?.LOCALE?.theme,
		)
	);
};

LoginPage.propTypes = {
	ssoConnection: PropTypes.object,
	isMarketplace: PropTypes.bool,
	mfaRequired: PropTypes.bool,
	csrfToken: PropTypes.string.isRequired,
	googleUrl: PropTypes.string,
};

LoginPage.defaultProps = {
	ssoConnection: {},
	isMarketplace: false,
	mfaRequired: false,
	googleUrl: '',
};

export default LoginPage;
